import { render } from "./ImageVCode.vue?vue&type=template&id=50b1e4d5&scoped=true"
import script from "./ImageVCode.vue?vue&type=script&lang=js"
export * from "./ImageVCode.vue?vue&type=script&lang=js"

import "./ImageVCode.vue?vue&type=style&index=0&id=50b1e4d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b1e4d5"]])

export default __exports__